@if (label && appearance === 'outline') {
  <mat-label> {{ label | translate | async }}{{ required ? ' *' : '' }} </mat-label>
}
<mat-form-field [appearance]="appearance" [style.fontSize.px]="fontSize">
  <input
    matInput
    [name]="name"
    [style]="styles"
    [type]="type"
    [formControl]="control"
    [placeholder]="(placeholder | translate | async) + (required ? ' *' : '')"
    (change)="onInputChange(control.value)"
    (blur)="onTouched()"
    (input)="onTouched()"
  />

  @if (prefix) {
    <mat-icon class="search-icon" matPrefix>{{ prefix }}</mat-icon>
  }
  @if (prefixText) {
    <span matPrefix [innerHTML]="prefixText"></span>
  }

  @if (suffix) {
    <mat-icon matSuffix>{{ suffix }}</mat-icon>
  }
  @if (suffixText) {
    <span matSuffix [innerHTML]="suffixText"></span>
  }

  @if (control.touched) {
    <mat-error>
      @if (control.errors?.required) {
        @if (label || placeholder) {
          {{ label || placeholder | translate | async }}
          {{ 'is required' | translate | async }}
        } @else {
          {{ 'This field is required' | translate | async }}
        }
      }
      @if (!control.errors?.required && control.errors?.minlength) {
        {{ 'Required length for this filed is' | translate | async }}
        {{ control.errors?.minlength.requiredLength }}
      }
      @if (type === 'password' && !control.hasError('required')) {
        @if (control.errors?.minlength && !control.errors?.required) {
          <ng-container translate>
            Minimum length of this field must be equal or greater than 8 symbols. Leading
            and trailing spaces will be ignored.
          </ng-container>
        }
        @if (control.errors?.pattern && !control.errors?.minlength) {
          <ng-container translate>
            Minimum of different classes of characters in password is 3. Classes of
            characters: Lower Case, Upper Case, Digits, Special Characters.
          </ng-container>
        }
        @if (control.errors?.passwordMismatch) {
          <ng-container translate> Please enter the same value again. </ng-container>
        }
      }
      @if (
        control.hasError('email') ||
        (type === 'email' && control.hasError('pattern') && !control.hasError('required'))
      ) {
        <ng-container translate>
          Please enter a valid email address (Ex: johndoe&#64;domain.com).
        </ng-container>
      }
    </mat-error>
  }
</mat-form-field>
